<template>
  <Modal :id="'cmp-add-product_groups'" @cancelled="onCancel">
    <!-- <template slot="header">{{ $dft.snakeCaseToWords(ppkey) }}</template> -->
    <template slot="header">{{$t('new_product_group')}}</template>

    <template slot="body">
      <div class="form-group">
        <TextField
          :id="'product_group_name'"
          v-bind="textFieldConfig"
          :value="newProductGroupsName"
          :placeholder="$t('product_group_name')"
          @valuechanged="onTextFieldValueChange"
        />
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button s6 v1" @click.stop="onSaveProductGroups">
        {{$t('ok')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import TextField from "@plugins/text-field/text-field";
import { EventHooks } from "../../../../plugins/text-field";
import { ProductGroupsService } from "../../services/product-groups.service";
import { async } from "rxjs/internal/scheduler/async";
export default {
  components: {
    Modal,
    TextField,
  },
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
      newProductGroupsName: "",
    };
  },
  methods: {
    onTextFieldValueChange: function (name, value) {
      // this.$emit('changed', {name, value});
      this.newProductGroupsName = value;
      console.log("new name", this.newProductGroupsName);
    },
    onSaveProductGroups: async function () {
      console.log("OK");
      const res = await ProductGroupsService.addNewProductGroups(
        this.newProductGroupsName
      );
      this.$emit("added", res.data);
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style></style>
